import type { SpecialItem } from '@/types/media';

export const specials: SpecialItem[] = [
  {
    id: 's1',
    title: '星际漫游专题',
    subtitle: '在浩瀚星海中寻找人类的方向',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20space%20odyssey%20collection%20banner%20with%20distant%20rose%20colored%20galaxy%2C%20stars%20and%20soft%20nebula%2C%20elegant%20artistic%20minimal%20composition%2C%20high%20detail&width=1200&height=675&seq=special-space-odyssey&orientation=landscape',
    description: '从近未来到遥远星海，精选科幻与冒险题材影视，带你踏上一次关于未知与勇气的旅程。',
    mediaIds: ['m1', 'm7', 't1', 'm5'],
  },
  {
    id: 's2',
    title: '古装悬疑精选',
    subtitle: '盛世繁华下的暗流涌动',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20Chinese%20mystery%20collection%20banner%20with%20lanterns%20and%20misty%20courtyard%2C%20rose%20and%20gold%20palette%2C%20elegant%20painterly%20minimal%20style&width=1200&height=675&seq=special-ancient-mystery&orientation=landscape',
    description: '长安谜案、江湖恩怨、名门兴衰，古典氛围与缜密推理交织，为你呈现东方悬疑的独特魅力。',
    mediaIds: ['m2', 't4', 't9', 't11'],
  },
  {
    id: 's3',
    title: '治愈深夜档',
    subtitle: '给忙碌生活的一剂温柔',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20healing%20collection%20banner%20of%20cozy%20warm%20lights%20and%20soft%20pink%20night%20ambience%2C%20gentle%20minimal%20artistic%20style%2C%20high%20detail&width=1200&height=675&seq=special-healing-night&orientation=landscape',
    description: '美食、家庭与平凡的日常，这些温暖的作品适合在深夜静静观看，安抚奔波了一天的你。',
    mediaIds: ['t12', 'm8', 'm4', 't6'],
  },
  {
    id: 's4',
    title: '都市情感特辑',
    subtitle: '在钢筋森林里遇见彼此',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20romance%20collection%20banner%20with%20modern%20city%20skyline%20at%20dusk%2C%20soft%20pink%20and%20mauve%20sky%2C%20elegant%20minimal%20artistic%20style&width=1200&height=675&seq=special-urban-romance&orientation=landscape',
    description: '从地铁口的相遇，到云层之上的奔赴，精选都市爱情与职场故事，献给每一个认真生活的你。',
    mediaIds: ['m11', 'm6', 't3', 't8'],
  },
];